export default function LoadingButtonText({ loading, text, loadingText }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "10px",
        whiteSpace: 'nowrap'
      }}
    >
      {loading && (
        <div
          className="p_load"
          style={{
            width: "10px",
            height: "10px",
            borderWidth: "4px",
            borderTop: "4px solid transparent",
          }}
        ></div>
      )}
      <div>{loading ? loadingText : text}</div>
    </div>
  );
}
